import axios, { AxiosResponse } from 'axios';
import { Toast } from 'vant';

/**
 *
 * @param token 待拼装的token
 * @description 自动拼装token的函数
 * @returns 输出Bearer + token的字符串
 */
export const tokenTransformer = (token: string) => {
  const tokenType = 'Bearer';
  if (token.includes(tokenType)) {
    return token;
  } else {
    return `${tokenType} ${token}`;
  }
};

export const userAuthGuardHandler = (res: AxiosResponse<any>) => {
  const USER_EXPIRE = 302;
  const USER_NOTFOUND = 301;
  const IS_APP = !!window.udid;
  const newerToken = res.headers.authorization || res.headers.Authorization;
  // * 当服务器刷新token时重新写入token到本地
  if (newerToken && IS_APP) {
    // * 更新token给app
    const jsonData = JSON.stringify({
      action: 'mRefreshToken',
      data: newerToken,
    });
    console.log('sync newer token to app.');
    window.handleMessage(jsonData);
    const AppVersionNum = Number(window.version.split('.').join(''));
    const versionBoundary = 485;
    // ! 由于iOS端缺少返回token函数，此处手动修改window全局gettoken()方法返回值
    if (AppVersionNum < versionBoundary && window.isIOS) {
      window.gettoken = () => newerToken;
    }
  } else if (
    (res.data.statusCode === USER_EXPIRE ||
      res.data.statusCode === USER_NOTFOUND) &&
    IS_APP
  ) {
    // * 当服务器拒绝自动刷新token时，需重定向到登录页
    const option = {
      action: 'mUserLogin',
      data: '登录状态过期，请重新登录',
    };
    window.handleMessage(JSON.stringify(option));
  }
};

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

// 拦截器
http.interceptors.request.use((config: any) => {
  // 如果是请求后端签名上传图片接口，则不加token请求头
  const regForUploader = new RegExp('/oss/upload/get.php');
  const regForUploader2 = new RegExp(process.env.VUE_APP_OSS);
  const WAP_API_STATE = config.url!.includes('api/');
  if (config.url!.includes('v1/')) {
    config.baseURL = process.env.VUE_APP_CQCB_AP_GO;
  }
  if (config.url.includes('v1/dscm')) {
    config.baseURL = process.env.VUE_APP_CQCB_AP_DATA;
  }
  if (WAP_API_STATE) {
    config.baseURL = process.env.VUE_APP_CQCB_API;
  }
  if (
    window.gettoken() &&
    window.gettoken() !== 'null' &&
    !regForUploader.test((config as any).url) &&
    !regForUploader2.test((config as any).url)
  ) {
    // 如果请求的是wap api，更换header name
    if (WAP_API_STATE) {
      config.headers.Authorization = tokenTransformer(window.gettoken());
    } else {
      config.headers.token = tokenTransformer(window.gettoken());
    }
  }
  // * 设置app标识字段udid & appkey

  if (
    window.udid &&
    window.appkey &&
    !config.url.includes(process.env.VUE_APP_OSS)
  ) {
    config.headers.udid = window.udid;
    config.headers.appkey = window.appkey;
  }
  return config;
});

http.interceptors.response.use(
  (res) => {
    if (res && res.status === 200 && res.data) {
      userAuthGuardHandler(res);
      return res.data;
    } else {
      return Promise.reject();
    }
  },
  (err) => {
    const { response = {} } = err;
    if (response.status === 500) {
      Toast.loading({
        duration: 3000,
        message: '服务器开小差了,后台工作人员正在努力解决',
      });
    }
  },
);
export { http };
